import { useCallback } from "react";
import NoteListCardItem from "./items/NoteListCardItem";

const NotebookList = ({notebooks, searchText, onSelectNotebook }) => {
  // Memoize the click handler to prevent recreation on every render (rerender-memo)
  const handleNotebookClick = useCallback((notebook) => {
    onSelectNotebook(notebook);
  }, [onSelectNotebook]);
  
  return (
    <>
      <div>
        {notebooks.length === 0 && `no notebooks found '${searchText}'`}
      </div>
      {notebooks.map((notebook) => {
        return (
          <NoteListCardItem
            key={notebook.id}
            item={notebook}
            type="notebook"
            onClick={handleNotebookClick}
            data-bs-dismiss="offcanvas"
          />
        );
      })}
    </>
  );
};

export default NotebookList;
